import * as React from 'react';
import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/utils';
import { Button } from '../../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';

export interface ActionBarProps {
  children: React.ReactNode;
  className?: string;
}

export function ActionBar({ children, className }: ActionBarProps): React.JSX.Element {
  return (
    <div className={cn('flex animate-fade-in shrink-0 flex-wrap items-center gap-1.5', className)}>{children}</div>
  );
}

export interface ActionBarDividerProps {
  className?: string;
}

export function ActionBarDivider({ className }: ActionBarDividerProps): React.JSX.Element {
  return <div className={cn('h-5 w-px bg-border', className)} />;
}

export interface ActionBarSpacerProps {
  className?: string;
}

export function ActionBarSpacer({ className }: ActionBarSpacerProps): React.JSX.Element {
  return <div className={cn('flex-1', className)} />;
}

export interface ActionBarResetButtonProps {
  onClick: () => void;
}

export function ActionBarResetButton({ onClick }: ActionBarResetButtonProps): React.JSX.Element {
  const { t } = useTranslation('common');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button className="h-9 w-9 shadow-none" onClick={onClick} size="icon" variant="outline">
          <RotateCcw className="h-4 w-4 text-muted-foreground" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{t('actions.reset')}</TooltipContent>
    </Tooltip>
  );
}
